import { createSelector } from 'reselect'
import { reduce } from 'lodash'

/**
 * Selector to get the state of a subresource in a flat structure. Subresource's handled by the "reducerForSubresource"
 * are stored in the store in a 2 level structure - sorted by the key of the parent entity.
 *
 * e.g.
 * {
 *     '123': {
 *         '321': { documentId: '321', orderId: '123', ...},
 *         '654': { documentId: '654', orderId: '123', ...}
 *     },
 *     '456': {
 *         '789': { documentId: '789', orderId: '456', ...},
 *         '000': { documentId: '000', orderId: '456', ...}
 *     }
 * }
 *
 * @param {Function} rawSelector - Selector to retrieve the raw subresource state with 2 level structure from the store.
 * @return {Function}
 */
export const createSubresourceFlatSelector = rawSelector => {
    if (typeof rawSelector !== 'function') {
        throw new Error('"rawSelector" function missing to create subresource flat selector!')
    }

    return createSelector(rawSelector, rawSubresourceState => {
        return reduce(
            rawSubresourceState,
            (accumulator, value) => {
                return Object.assign(accumulator, value)
            },
            {}
        )
    })
}
